<template>
  <v-card class="ma-0 pa-0">
    <v-card-title
      style="background-color: #82a1d0; position: sticky; top: 0; z-index: 1"
      background-color="primary"
      class="d-flex justify-space-between"
    >
      <v-row>
        <div class="filter-search-container mx-3">
          <div class="filter-container mx-1">
            <v-menu v-model="menu" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on" class="filter-btn" icon>
                  <v-icon color="blue-grey darken-1">mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="option in filterOptions"
                  :key="option.value"
                  @click="setFilter(option.value)"
                >
                  <v-list-item-title>{{ option.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="search-container">
            <v-text-field
              v-if="selectedFilter !== 'etiqueta'"
              dense
              solo
              v-model="filterValue"
              :key="selectedFilter"
              :placeholder="currentPlaceholder"
              append-icon="mdi-magnify"
              single-line
              hide-details
              class="search"
              flat
              @keyup.enter="applyFilter"
              :readonly="!selectedFilter || selectedActive"
              @click="activeMenu()"
            />
            <v-autocomplete
              v-else
              v-model="selected"
              small-chips
              dense
              solo
              flat
              hide-details
              append-icon="mdi-tag-multiple"
              :label="$tc('commons.group')"
              class="autocomplete"
              :items="getTags"
              item-text="text"
              item-value="id"
              @input="changesTags()"
            >
              <template v-slot:selection="{ item }">
                <v-chip
                  v-if="selected !== null"
                  :color="item.color"
                  id="chip-tag"
                  small
                  close
                  @click:close="selected = null"
                >
                  <span>{{ item.text }}</span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-chip id="chip-tag" small :color="item.color">
                  {{ item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                @click="resetFilter"
                :disabled="!selectedFilter && !filterValue"
                class="reset-btn mx-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ $tc("gestionEmpleados.resetFilter") }}</span>
          </v-tooltip>
        </div>
        <div class="filter-search-container">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="handleItemsSelect"
                color="blue-grey darken-1"
                icon
                class="ml-1"
                :disabled="
                  !verifyExistingAction('accion:modificaretiquetasempleado')
                "
              >
                <v-icon>mdi-tag-plus</v-icon>
              </v-btn>
            </template>
            <span>Asignar etiquetas</span>
          </v-tooltip>

          <v-dialog v-model="tagDialog" max-width="400px" persistent>
            <v-card class="pa-0">
              <v-card-title class="d-flex justify-center">
                {{
                  showAddTag === false
                    ? "Asignar etiquetas"
                    : "Agregar etiqueta nueva"
                }}
              </v-card-title>
              <v-tooltip bottom v-if="!showAddTag">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="add-tag"
                    v-bind="attrs"
                    v-on="on"
                    @click="showAddTag = true"
                    >mdi-tag-plus</v-icon
                  >
                </template>
                <span>Agregar etiqueta</span>
              </v-tooltip>

              <v-card-text :class="{ 'mt-n5': showAddTag == false }">
                <v-form ref="form" v-model="formValid" v-if="!showAddTag">
                  <v-autocomplete
                    v-model="selectedRow"
                    :items="getEmployees"
                    item-value="id"
                    item-text="fullName"
                    label="Selecciona un empleado"
                    outlined
                    dense
                    :rules="[(v) => !!v || 'Este campo es requerido']"
                    :search-input.sync="searchEmployeed"
                  />
                  <v-autocomplete
                    v-model="selectedTagsGroup"
                    :items="getTagsFilter(selectedRow)"
                    item-value="id"
                    item-text="text"
                    label="Selecciona etiquetas"
                    multiple
                    outlined
                    dense
                    chips
                    :disabled="!selectedRow"
                    :rules="[
                      (v) => (!!v && v.length > 0) || 'Este campo es requerido',
                    ]"
                    :search-input.sync="searchTag"
                  >
                    <template v-slot:item="data">
                      <div style="display: flex; align-items: center">
                        <div
                          :style="{
                            backgroundColor: data.item.color,
                            width: '20px',
                            height: '20px',
                            marginRight: '10px',
                          }"
                        ></div>
                        <span>{{ data.item.text }}</span>
                      </div>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        :key="data.item.id"
                        :color="data.item.color"
                        text-color="white"
                        close
                        small
                        @click:close="removeTag(data.item)"
                      >
                        {{ data.item.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-form>
                <v-form ref="form" v-model="formValid" v-else>
                  <v-text-field
                    name="text"
                    v-model="name"
                    :label="this.$tc('reports.labelsTitle')"
                    outlined
                    :rules="rules"
                    dense
                    class="ma-0"
                  />
                  <v-text-field
                    name="description"
                    v-model="description"
                    :label="this.$tc('reports.labelsDescription')"
                    outlined
                    :rules="rules"
                    dense
                    class="ma-0"
                  />
                  <v-color-picker
                    v-model="color"
                    class="mx-auto mb-4"
                    :swatches="swatches"
                    show-swatches
                    hide-canvas
                    hide-sliders
                    hide-inputs
                  />
                </v-form>
              </v-card-text>
              <v-card-actions class="d-flex justify-space-between mt-n5">
                <v-btn
                  color="red"
                  text
                  @click="cancelDialogTag"
                  v-if="!showAddTag"
                >
                  Cancelar
                </v-btn>
                <v-btn color="red" text @click="showAddTag = false" v-else
                  >Cancelar</v-btn
                >
                <v-btn
                  color="primary"
                  text
                  @click="validateAndSave"
                  :disabled="!formValid"
                  v-if="!showAddTag"
                >
                  Aceptar
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="addTag()"
                  :disabled="!formValid"
                  v-else
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-row>
      <v-col cols="auto my-n4 pr-0">
        <v-row class="justify-start ma-0 border">
          <!-- Botón de Refresh -->
          <v-col cols="auto pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="refreshItems"
                  class="btn-table ma-1"
                  small
                >
                  <v-icon
                    :class="{ loader: loading4 }"
                    :loading="loading4"
                    :disabled="loading4"
                    id="icon-add"
                    class="mx-auto"
                    size="19"
                  >
                    fas fa-sync-alt
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $tc("commons.refresh") }}</span>
            </v-tooltip>
          </v-col>
          <!-- Botón de Añadir -->
          <v-col cols="auto pa-0">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="white" dark icon class="btn-table ma-1" small>
                    <v-icon
                      size="20"
                      class="mx-auto"
                      id="icon-add"
                      v-bind="attrs"
                      v-on="on"
                      @click="openDialog()"
                      :disabled="
                        !verifyExistingAction('accion:agregarempleado')
                      "
                    >
                      fas fa-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.add") }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-card-title>
    <v-row class="d-flex justify-space-aroud pa-0 ma-0 card_container">
      <v-col
        v-if="getEmployees.length === 0"
        cols="12"
        class="d-flex justify-center"
      >
        {{ $tc("editRegistrations.notData") }}
      </v-col>
      <v-col
        v-for="item in getEmployees"
        :key="item.empId"
        cols="12"
        xs="12"
        sm="6"
        md="3"
        xl="2"
        class="d-flex justify-center"
      >
        <v-card class="card">
          <v-card-actions>
            <v-avatar size="100">
              <v-img
                :src="item.preview"
                max-height="150"
                max-width="250"
                v-if="item.preview"
              ></v-img>
              <img src="../../../assets/avatar.png" alt="user" v-else />
            </v-avatar>
          </v-card-actions>
          <v-card-subtitle style="padding: 0px">{{
            item.file
          }}</v-card-subtitle>
          <v-card-title style="max-width: 223px">
            <div style="">
              <p class="card__title text-clamp" style="overflow: hidden">
                {{ truncateText(item.lastName) }}
              </p>
            </div>
          </v-card-title>
          <v-card-subtitle>
            {{ item.name }}
          </v-card-subtitle>
          <v-row
            class="ma-auto d-flex justify-space-around"
            style="width: 100%"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon :color="stateColor(item)">
                    {{ stateIcon(item).icon }}
                  </v-icon>
                </span>
              </template>
              <span>{{ stateTooltip(item) }}</span>
            </v-tooltip>

            <div v-if="item.tagColors && item.tagColors.length > 0">
              <div class="text-center">
                <v-menu
                  offset-y
                  :value="openMenus[item.empId]"
                  @input="(val) => (openMenus[item.empId] = val)"
                >
                  <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-tooltip bottom>
                      <template
                        v-slot:activator="{
                          on: tooltipOn,
                          attrs: tooltipAttrs,
                        }"
                      >
                        <div
                          class="color-bar"
                          v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                          v-on="{ ...menuOn, ...tooltipOn }"
                        >
                          <div
                            @click="
                              !verifyExistingAction(
                                'accion:veretiquetasempleado'
                              )
                                ? null
                                : showTag(item.empId)
                            "
                            v-for="(color, index) in item.tagColors"
                            :key="index"
                            :style="{
                              backgroundColor: color,
                              width: segmentWidth(item.tagColors),
                              height: '25px',
                            }"
                          />
                        </div>
                      </template>
                      <span>{{ $tc("gestionEmpleados.showTags") }}</span>
                    </v-tooltip>
                  </template>

                  <v-list dense>
                    <v-list-item v-for="(tag, index) in tagEmp" :key="index">
                      <v-list-item-title>
                        <v-chip :color="tag.color" small id="chip-tag">
                          {{ tag.nombre }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    @click="goToMonthlyRecord(item)"
                    id="icon-edit"
                    :disabled="
                      !verifyExistingAction('accion:fichamensualempleado')
                    "
                    >fas fa-calendar</v-icon
                  >
                </span>
              </template>
              <span>{{ $tc("monthlyRecord.monthlyRecord") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.downDate === null">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    @click="goToFormEnrollment(item)"
                    id="icon-edit"
                    :disabled="
                      !verifyExistingAction('accion:enrolamientoempleado')
                    "
                    >fas fa-fingerprint</v-icon
                  >
                </span>
              </template>
              <span>{{ $tc("gestionEmpleados.showEnrollment") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    @click="goToEmployed(item)"
                    id="icon-edit"
                    :disabled="
                      !verifyExistingAction('accion:modificarempleado')
                    "
                    >fas fa-pen</v-icon
                  >
                </span>
              </template>
              <span>{{ $tc("editRegistrations.edit") }}</span>
            </v-tooltip>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showMonthlyRecord" max-width="1000" fullscreen>
      <Calendar @close="closeDialog" />
    </v-dialog>

    <v-dialog
      v-model="showUserNotExist"
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="d-flex justify-center">
          {{ this.$tc("gestionEmpleados.userNotExist") }}
        </v-card-title>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn class="bt-acept-blue" @click="closeDialog">{{
            this.$tc("newController.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="thereIsNoInterfaceDevice"
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="d-flex justify-center">
          {{ this.$tc("gestionEmpleados.thereIsNoInterfaceDevice") }}
        </v-card-title>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn class="bt-acept-blue" @click="closeDialog">{{
            this.$tc("newController.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showFormEnrollment"
      @keydown.esc="cancelChanged"
      persistent
      max-width="700px"
    >
      <FormEnrollment
        :key="formKeyEnrollement"
        @cancel="closeDialog"
        @save="confirmEnroll"
        :employeed="employeed"
      />
    </v-dialog>
    <v-dialog
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
      v-model="showDialog"
    >
      <DialogConfirm
        :titleChanged="titleChanged"
        @confirmChanged="confirmChanged"
        @cancelChanged="cancelChanged"
      />
    </v-dialog>
    <v-dialog
      v-if="showAdd"
      class="dialogShow"
      max-width="700px"
      style="overflow-x: hidden"
      persistent
      return-value="value"
      :key="formKey"
    >
      <AddEmployee />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>

<script>
import AddEmployee from "./Employee/AddEmployee.vue";
import DialogConfirm from "./DialogConfirm.vue";
import moment from "moment";
import Calendar from "./Calendar.vue";
import FormEnrollment from "./FormEnrollment.vue";
import Snackbar from "../../Complement/Snackbar.vue";
import { getConfig } from "@/config";

export default {
  components: {
    AddEmployee,
    DialogConfirm,
    Calendar,
    FormEnrollment,
    Snackbar,
  },
  data() {
    return {
      thereIsNoInterfaceDevice: false,
      showMonthlyRecord: false,
      showFormEnrollment: false,
      showUserNotExist: false,
      calendarDate: moment().startOf("month").format("YYYY-MM-DD"),
      formKey: 0,
      filter: "",
      titleChanged: "",
      employedChanged: null,
      showDialog: false,
      loader: null,
      loading: false,
      loading4: false,
      menu: false,
      filterOptions: [
        { text: "Nombre", value: "nombre" },
        { text: "Apellido", value: "apellido" },
        { text: "Nombre y Apellido", value: "nombre+apellido" },
        { text: "Legajo", value: "legajo" },
        { text: "Número de Documento", value: "ndoc" },
        { text: "Etiqueta", value: "etiqueta" },
        { text: "Activos", value: "activos" },
      ],
      selected: null,
      tagDialog: false,
      formValid: false,
      selectedTagsGroup: [],
      searchTag: "",
      selectedRow: null,
      searchEmployeed: "",
      showAddTag: false,
      swatches: [
        ["#E10000", "#AA0000", "#550000", "#FF00F1"],
        ["#EAEA12", "#AAAA00", "#555500", "#CD00FF"],
        ["#07B207", "#009000", "#005500", "#800080"],
        ["#32D4D4", "#00AAAA", "#005555", "#373BA8"],
        ["#0000CD", "#0000AA", "#000055", "#4500FF"],
      ],
      name: "",
      description: "",
      color: "#E10000",
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      alert: false,
      textAlert: "",
      openMenus: {},
      employeed: null,
      formKeyEnrollement: 0,
      _config: null,
      selectedActive: false,
    };
  },
  mounted() {
    this.$store.dispatch("tags/getTags");
  },
  computed: {
    config() {
      if (!this._config) {
        const cfg = getConfig();
        if (!cfg) throw new Error("Config not loaded");
        this._config = cfg;
      }
      return this._config;
    },
    tagEmp() {
      return this.$store.state.tags.tagsEmp.etiquetas;
    },
    getTags() {
      return this.$store.state.tags.tags.filter(
        (tag) => tag.scope === "empleados"
      );
    },
    showAdd: {
      get() {
        return this.$store.state.employees.showAdd;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    getEmployees() {
      return this.$store.state.employees.employees || [];
    },
    currentPlaceholder() {
      return this.$store.getters["employees/currentPlaceholder"];
    },
    selectedFilter() {
      return this.$store.state.employees.selectedFilter;
    },
    filterValue: {
      get() {
        return this.$store.state.employees.filterValue;
      },
      set(newvalue) {
        this.$store.state.employees.filterValue = newvalue;
      },
    },
  },
  mutations: {
    setTagsEmp(state, payload) {
      state.tagsEmp = payload;
    },
  },
  methods: {
    confirmEnroll() {
      this.showFormEnrollment = false;
      this.loading = false;
      this.showAlert(this.$tc("enrollement.addEnrollementSuccess"), "#82A1D0");
    },
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
    async showTag(idEmp) {
      localStorage.setItem("empId", idEmp);
      this.$store.commit("tags/setTagsEmp", { etiquetas: [] });
      this.openMenus = {};
      await this.$store.dispatch("tags/getOneEmpTags");
      this.$set(this.openMenus, idEmp, true);
    },
    segmentWidth(colors) {
      return `${100 / colors.length}%`;
    },
    getTagsFilter(employeed) {
      let tagsFilter = [];
      let empSelected = this.getEmployees.find((emp) => emp.id === employeed);

      if (empSelected !== undefined) {
        tagsFilter = this.getTags.filter(
          (tag) =>
            !empSelected.tags.some((empTag) => empTag.etiquetaId === tag.id)
        );
      }
      return tagsFilter;
    },
    async addTag() {
      let payload = {
        nombre: this.name,
        descripcion: this.description,
        color: this.color,
        alcance: "empleados",
      };

      await this.$store.commit("tags/setNewTag", payload);
      await this.$store.dispatch("tags/addTag");
      let tagAdd = this.getTags.find((tag) => tag.text === this.name);

      this.selectedTagsGroup = [tagAdd.id];
      this.name = "";
      this.description = "";
      this.color = "#E10000";
      this.showAddTag = false;
    },
    activeMenu() {
      if (this.selectedFilter === null) {
        this.menu = true;
      }
    },
    handleItemsSelect() {
      this.tagDialog = true;
    },
    cancelDialogTag() {
      this.tagDialog = false;
      this.$refs.form.reset();
      this.selectedRow = null;
      this.selectedTagsGroup = [];
      this.searchEmployeed = "";
      this.searchTag = "";
    },
    removeTag(tag) {
      this.selectedTagsGroup = this.selectedTagsGroup.filter(
        (item) => item !== tag.id
      );
    },
    validateAndSave() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.saveSelectedTags();
        this.showAlert(this.$tc("gestionEmpleados.addTagSuccess"), "#82A1D0");
      }
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    saveSelectedTags() {
      let payload = {
        empId: this.selectedRow,
        etiquetas: this.selectedTagsGroup,
      };
      this.$store.commit("tags/setNewTag", payload);
      this.$store.dispatch("tags/addTagsEmpGroup").then(async () => {
        this.cancelDialogTag();
        await this.$store.dispatch("employees/getEmployeesPaginate");
      });
    },
    async changesTags() {
      if (this.selected !== null) {
        let where = {
          etiqueta: this.selected,
        };
        await this.$store.dispatch("employees/updateWhere", where);
      }
    },
    closeDialog() {
      this.thereIsNoInterfaceDevice = false;
      this.showMonthlyRecord = false;
      this.calendarDate = moment().startOf("month").format("YYYY-MM-DD");
      this.showFormEnrollment = false;
      this.showUserNotExist = false;
      this.loading = false;
    },
    setFilter(value) {
      if (value === "activos") {
        this.selectedActive = true;
        this.dispatchOnlyActive();
      } else {
        this.$store.commit("employees/setOnlyActive", false);
        this.selectedActive = false;
      }
      this.$store.commit("employees/setSelectedFilter", value);
    },
    async dispatchOnlyActive() {
      this.loading = true;
      this.$store.commit("employees/setOnlyActive", true);
      this.$store.commit("employees/setSelectedFilter", null);
      this.$store.commit("employees/setLimit", 44);
      this.$store.commit("employees/setWhere", {});
      await this.$store.dispatch("employees/getEmployeesPaginate");
      this.loading = false;
    },
    async applyFilter() {
      this.loading = true;
      if (!this.selectedFilter || !this.filterValue.trim()) {
        return;
      }
      let where = {};
      if (this.selectedFilter === "nombre+apellido") {
        const [nombre, apellido] = this.filterValue.trim().split(" ");
        if (nombre) where.nombre = nombre;
        if (apellido) where.apellido = apellido;
      } else {
        where = {
          [this.selectedFilter]: this.filterValue.trim(),
        };
      }
      await this.$store.dispatch("employees/updateWhere", where);
      this.loading = false;
    },
    async resetFilter() {
      this.selected = null;
      this.loading = true;
      this.$store.commit("employees/setOnlyActive", false);
      this.$store.commit("employees/setFilterValue", "");
      this.$store.commit("employees/setSelectedFilter", null);
      this.$store.commit("employees/setLimit", 44);
      this.$store.commit("employees/setWhere", {});
      await this.$store.dispatch("employees/getEmployeesPaginate");
      this.loading = false;
    },
    async refreshItems() {
      this.loading = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
    truncateText(item) {
      const maxLength = 12;
      return item.length > maxLength
        ? item.substring(0, maxLength) + "..."
        : item;
    },
    employeeState(employed) {
      if (employed.downDate === null) {
        return true;
      }

      const today = moment();
      const downDate = moment(employed.downDate);
      return downDate.isSameOrAfter(today);
    },
    stateColor(employed) {
      const isActive = this.employeeState(employed);
      return isActive ? "green" : "red";
    },
    stateIcon(employed) {
      const isActive = this.employeeState(employed);
      return {
        icon: isActive ? "fas fa-user-check" : "fas fa-user-times",
      };
    },
    stateTooltip(employed) {
      const isActive = this.employeeState(employed);
      return isActive
        ? this.$tc("gestionEmpleados.active")
        : this.$tc("gestionEmpleados.inactive");
    },
    cancelChanged() {
      this.thereIsNoInterfaceDevice = false;
      this.showUserNotExist = false;
      this.showFormEnrollment = false;
      this.loading = false;
      this.showDialog = false;
      this.employedChanged = null;
    },
    confirmChanged() {
      if (this.employedChanged !== null) {
        this.$store.commit("employees/setEditEmployed", this.employedChanged);
        if (this.employedChanged.isEnabled) {
          this.$store.commit(
            "employees/setIsEnabled",
            !this.employedChanged.isEnabled
          );
          this.$store.dispatch("employees/disabledEmployed");
          this.showDialog = false;
        } else {
          this.$store.commit(
            "employees/setIsEnabled",
            !this.employedChanged.isEnabled
          );
          this.$store.dispatch("employees/enabledEmployed");
          this.showDialog = false;
        }
      }
    },
    goToEmployed(item) {
      localStorage.setItem("empId", item.empId);
      this.$router.push(`/GestionEmpleados/info/${item.empId}`);
      this.$store.commit("employees/setItemsEmployed", { ...item });
    },
    async goToFormEnrollment(item) {
      this.formKeyEnrollement++;
      this.loading = true;
      this.employeed = item;
      if (this.config.enroll) {
        if (this.config.enroll === "suprema") {
          const userExists = await this.$store.dispatch(
            "employees/getInfoUser",
            item.empId
          );
          if (userExists) {
            this.showFormEnrollment = true;
          } else {
            this.showUserNotExist = true;
          }
        }
      } else {
        this.thereIsNoInterfaceDevice = true;
      }
    },
    async goToMonthlyRecord(item) {
      item.fecDesde = this.calendarDate;
      this.loading = true;
      await this.$store.dispatch("employees/getMontlyTab", item).then(() => {
        this.loading = false;
        this.showMonthlyRecord = true;
      });
    },
    openDialog() {
      this.formKey++;
      this.showAdd = true;
      this.$store.commit("employees/setShowAdd", true);
      this.showAdd = true;
      this.$store.commit("employees/setShowAdd", true);
      this.$store.dispatch("changeGroup/getGroups");
      this.$store.dispatch("changeSchedule/getSchedules");
      this.$store.dispatch("assignCards/getCardsAssign");
      this.$store.dispatch("gestionTiempos/getModels");
    },
  },
};
</script>

<style scoped>
.color-bar {
  display: flex;
  width: 50px;
  height: 25px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  margin-top: 2px;
}

.add-tag {
  position: relative;
  top: -40px;
  left: 350px;
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.card_container {
  min-height: 400px;
  max-height: 62vh;
  overflow-y: scroll;
  scrollbar-width: unset;
  max-width: 100%;
}

.card {
  width: 223px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 290px !important;
  border: 3px outset #9cb6da;
  background-color: rgb(241, 244, 247);
}

.card:hover {
  border: 3px outset #39537a;
  transform: translateY(-10px);
  box-shadow: -5px -1px 28px 0px rgba(0, 0, 0, 0.75) !important;
}

.card__title {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.search {
  max-width: 500px !important;
}
.autocomplete {
  padding: 0px;
  margin: 0px;
  max-width: 290px !important;
}

#chip-tag {
  color: #ffffff;
  text-shadow: 0px 1px 4px #000000be;
}

#icon-add {
  color: #ffffff;
  margin-right: 8px;
}

#icon-edit {
  color: #39537a;
  font-size: 20px;
}

#icon-edit:hover {
  color: #042251 !important;
  animation: bounce 0.5s ease-in-out;
  font-size: 20px;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0); /* Posición inicial y final */
  }
  50% {
    transform: translateY(-5px); /* Salto hacia arriba */
  }
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.bt-acept-blue {
  background-color: #39537a !important;
  color: white !important;
}
.filter-search-container {
  display: flex;
  align-items: center;
  border-radius: 15px;
  background-color: #a5b9d7;
}

.filter-container {
  display: flex;
}

.search-container {
  flex-grow: 1;
}
.day-highlight-green {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #c8e6c9;
  height: 150%;
  width: 150%;
  cursor: pointer;
}
.day-highlight-red {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  height: 150%;
  width: 150%;
  cursor: pointer;
}

.custom-chip {
  margin-top: 10px;
  font-size: 0.75rem; /* Tamaño de texto entre small (0.875rem) y x-small (0.625rem) */
  height: 22px; /* Ajusta la altura a un valor intermedio */
  padding: 0 8px; /* Espaciado interno */
  line-height: 20px; /* Asegura que el texto esté centrado */
  border-radius: 12px; /* Mantiene el estilo redondeado */
}
.legend-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: inline-block;
}

.legend-text {
  font-size: 0.8rem; /* Tamaño de texto reducido */
}
</style>
